import { useMemo } from "react";
import CloseIcon from "../../../compoenets/atom/icons/CloseIcon";
import { AttendResponse, AttendResponseType } from "../../../types/block/enum";
import { AttendeeType } from "../../../types/block/type";
import findAttendByEmail from "../../../utils/taskDetail/findAttendByEmail";
import styles from "./GuestModal.module.css";

interface SelectedGuestItemProps {
  data: AttendeeType[];
  email: string;
  onDelete: (email: string) => void;
  isSelfTask: boolean;
  responseStatus: AttendResponseType;
  organizer: boolean;
}

const SelectedGuestItem = ({
  data,
  email,
  onDelete,
  isSelfTask,
  responseStatus,
  organizer,
}: SelectedGuestItemProps) => {
  const { name, imgUrl } = findAttendByEmail(data, email);

  const iconStyle: React.CSSProperties = useMemo(() => {
    const baseStyle: React.CSSProperties = {
      backgroundSize: "cover",
    };

    if (imgUrl) {
      baseStyle.backgroundImage = `url(${imgUrl})`;
    } else {
      baseStyle.backgroundColor = "white";
      baseStyle.borderRadius = "50%";
    }

    return baseStyle;
  }, [imgUrl]);

  return (
    <div className={styles["selected-guest-row"]}>
      <div className={styles.selectedGuestRowIconWrapper}>
        <div
          className={styles["selected-guest-row-icon"]}
          style={iconStyle}
        ></div>
        {(responseStatus === AttendResponse.ACCEPTED || organizer) && (
          <span className={styles.acceptedIcon} />
        )}
        {responseStatus === AttendResponse.DECLINED && <span className={styles.declinedIcon} />}
        {responseStatus === AttendResponse.TENTATIVE && <span className={styles.tentativeIcon} />}
      </div>

      {name === email || !name ? (
        <span className={styles["selected-guest-row-name"]}>{email}</span>
      ) : (
        <>
          <span className={styles["selected-guest-row-name"]}>{name}</span>
          <span className={styles["selected-guest-row-email"]}>{"(" + email + ")"}</span>
        </>
      )}

      {organizer && <div className={styles.organizerBadge}>Organizer</div>}
      {isSelfTask ? (
        <div
          className="absolute right-[3px] flex cursor-pointer items-center justify-center gap-2.5 rounded-[5px] bg-dropdown-dark p-1 opacity-0 hover:opacity-100"
          onClick={() => onDelete(email)}
        >
          <CloseIcon color="white" />
        </div>
      ) : null}
    </div>
  );
};

export default SelectedGuestItem;
